export class LogSourceWithPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "LogSourceWithPolicyTypeEnum",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "LogSourceLocation",
            "format": ""
        },
        {
            "name": "policy",
            "baseName": "policy",
            "type": "LlgResourcePolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogSourceWithPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
export var LogSourceWithPolicyTypeEnum;
(function (LogSourceWithPolicyTypeEnum) {
    LogSourceWithPolicyTypeEnum["Cloudtrail"] = "CLOUDTRAIL";
    LogSourceWithPolicyTypeEnum["Datadog"] = "DATADOG";
    LogSourceWithPolicyTypeEnum["Cloudwatch"] = "CLOUDWATCH";
    LogSourceWithPolicyTypeEnum["Splunk"] = "SPLUNK";
    LogSourceWithPolicyTypeEnum["GcpCloudLogging"] = "GCP_CLOUD_LOGGING";
})(LogSourceWithPolicyTypeEnum || (LogSourceWithPolicyTypeEnum = {}));
